import { ElementWithSettings } from "../ElementWithSettings";

export const hasSetting = (element: ElementWithSettings, key: string) => {
    if (!element || !element.settings) return false;
    return element.settings[key] !== undefined;
};

export const getSettingString = (
    element: ElementWithSettings,
    key: string,
    defaultValue?: string,
) => (hasSetting(element, key) ? String(element.settings[key]) : defaultValue);

export const getSettingNumber = (
    element: ElementWithSettings,
    key: string,
    defaultValue?: number,
) => {
    if (!element || !element.settings) return defaultValue;
    if (typeof element.settings[key] === "number") return element.settings[key];
    return Number(element.settings[key]) || defaultValue;
};

export const getSettingBoolean = (
    element: ElementWithSettings,
    key: string,
    ...trueValues: string[]
): boolean => {
    if (!element || !element.settings) return false;
    if (trueValues == null || trueValues.length === 0) {
        if (typeof element.settings[key] === "boolean") {
            return element.settings[key];
        }
        return getSettingBoolean(element, key, "Yes", "True");
    }
    return trueValues.some((t) => t.toUpperCase() === String(element.settings[key]).toUpperCase());
};

export const getSettingEnum = (element: ElementWithSettings, e: any, key: string) => {
    if (typeof element.settings[key] === "number") return element.settings[key];
    return e[String(element.settings[key] || 0)];
};
